import React, { FC } from 'react';
import { Skeleton, SkeletonProps } from '@material-ui/lab';
import styled from 'styled-components';

const ContentSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-left: 10px;
`;

export interface ConverastionListItemSkeletonProps {
  animation: SkeletonProps['animation'];
}

const ConverastionListItemSkeleton: FC<ConverastionListItemSkeletonProps> = ({ animation }) => (
  <>
    <Skeleton animation={animation} variant="circle" width={36} height={36} />
    <ContentSkeleton>
      <Skeleton animation={animation} height="60%" />
      <Skeleton animation={animation} height="40%" />
    </ContentSkeleton>
  </>
);

export default ConverastionListItemSkeleton;
